import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory, useParams } from 'react-router-dom';
import { createProgram } from '../../../api/services/programService';
import { getSchoolsByDistrict } from '../../../api/services/schoolService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';
//import Modal from '../../../components/modal';
import LayoutError from '../../../components/layoutError';
import Program from '../../../api/models/program';

type Params = {
  districtId: string;
};

const fetchSchools = async ({ districtId }: any) => {
  return await getSchoolsByDistrict(districtId);
};

const CreatePrograms = () => {
  const history = useHistory();

  const { districtId } = useParams<Params>();
  const [programName, setProgramName] = useState('');
  const [schools, setSchools] = useState<(number | undefined)[]>([]);
  const [visible, setVisible] = useState(false);
  /*const [disciplines, setDisciplines] = useState<number[]>([]);
  const [modalDisciplines, setModalDisciplines] = useState<number[]>([]);
  const [openDisciplines, setOpenDisciplines] = useState(false);*/

  const schoolsData = useAsync({ promiseFn: fetchSchools, districtId });
  /*const disciplineData = useAsync({ promiseFn: getDisciplines });*/

  const saveProgram = async () => {
    return await createProgram({
      name: programName,
      districtId: Number(districtId),
      isVisible: visible,
      schoolIds: schools,
      //disciplineIds: disciplines,
    });
  };

  const save = useAsync({
    deferFn: saveProgram,
    onResolve: (response) => {
      const program: Program = response.data;

      history.push(`/admin/districts/${districtId}/programs/${program.programId}`, {
        message: `${programName} added successfully!`,
      });
    },
  });

  const handleSchoolChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) {
      setSchools([...schools, parseInt(e.currentTarget.value)]);
    } else {
      setSchools([
        ...schools.filter((t) => t !== parseInt(e.currentTarget.value)),
      ]);
    }
  };

  /*const handleRemoveDiscipline = (id?: number) => {
    if (!id) return;

    setDisciplines([...disciplines.filter((d) => d !== id)]);
  };

  const handleModalDisciplineChange = (
    e: React.FormEvent<HTMLInputElement>
  ) => {
    if (e.currentTarget.checked) {
      setModalDisciplines([
        ...modalDisciplines,
        parseInt(e.currentTarget.value),
      ]);
    } else {
      setModalDisciplines([
        ...modalDisciplines.filter(
          (d) => d !== parseInt(e.currentTarget.value)
        ),
      ]);
    }
  };

  const SelectedDisciplines =
    disciplineData.data?.data.disciplines.filter((d) =>
      disciplines.includes(d.disciplineId ?? -1)
    ) ?? [];*/

  // Error handling
  if (schoolsData.error) return <LayoutError />;

  return (
    <Fragment>
      <Layout isLoading={
        schoolsData.isPending ||
        save.isPending
      }>
        <Fragment>
          <ResponseStatus state={save} />

          {/* Disciplines Modal */}
          <>
            {/*<Modal
            open={openDisciplines}
            onCancel={() => {
              setOpenDisciplines(false);
            }}
            onSave={() => {
              setDisciplines(modalDisciplines);
              setOpenDisciplines(false);
            }}
          >
            <Fragment>
              <div className='flex'>
                <div className='flex'>
                  <div className='flex items-center h-5'>
                    <input
                      name='all-disciplines'
                      type='checkbox'
                      className='primary-checkbox'
                      checked={
                        disciplineData.data?.data.disciplines.length ===
                        modalDisciplines.length
                      }
                      onChange={(e) => {
                        if (e.currentTarget.checked) {
                          const d =
                            disciplineData.data?.data.disciplines.map(
                              (d) => d.disciplineId ?? -1
                            ) ?? [];

                          setModalDisciplines(d);
                        } else {
                          setModalDisciplines([]);
                        }
                      }}
                    />
                  </div>
                  <div className='ml-3 text-sm'>
                    <label htmlFor='all-disciplines' className='primary'>
                      Select All
                    </label>
                  </div>
                </div>
              </div>
              <hr className='my-4' />
              <div className='flex flex-col'>
                {disciplineData.data?.data.disciplines.map((d, i) => {
                  const dip = `discipline_${i}`;

                  return (
                    <div key={dip} className='flex items-start py-1'>
                      <div className='flex items-center h-5'>
                        <input
                          id={dip}
                          name='discipline'
                          type='checkbox'
                          value={d.disciplineId}
                          checked={modalDisciplines.includes(d.disciplineId ?? -1)}
                          className='primary-checkbox'
                          onChange={handleModalDisciplineChange}
                        />
                      </div>
                      <div className='ml-3 text-sm'>
                        <label htmlFor={dip} className='primary'>
                          {d.name}
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Fragment>
          </Modal>*/}
          </>

          {/* General Information */}
          <div className='grid grid-cols-6 gap-6 mb-6'>
            <div className='col-span-6 sm:col-span-6'>
              <FieldInput
                name='program'
                label='Program Name'
                minLength={1}
                maxLength={25}
                onChange={(e) => setProgramName(e.target.value)}
                value={programName}
              />
              <p className="text-gray-500">Maximum 25 characters allowed.</p>

            </div>
            <div className='col-span-6 sm:col-span-6'>
              <div className='flex items-start'>
                <div className='flex items-center h-5'>
                  <input
                    id='is-visible'
                    name='is-visible'
                    type='checkbox'
                    className='primary-checkbox'
                    checked={visible}
                    onChange={(e) => setVisible(e.currentTarget.checked)}
                  />
                </div>
                <div className='ml-3 text-sm'>
                  <label htmlFor='is-visible' className='primary'>
                    Is Visible
                  </label>
                  <p className='text-gray-500'>
                    When checked, this program will be available in the timesheet
                    entry flow.
                  </p>
                </div>
              </div>
            </div>

            {/* Disciplines */}
            <div className='col-span-6 sm:col-span-6'>
              {/*<div className='flex mb-3 justify-between'>
                <div>
                  <label className='primary'>Disciplines</label>
                  <p className='text-sm text-gray-500'>
                    Select all applicable disciplines.
                  </p>
                </div>
                <div className='flex items-end'>
                  <button
                    className='callout'
                    onClick={() => {
                      setModalDisciplines(disciplines);
                      setOpenDisciplines(true);
                    }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='h-5 w-5'
                      viewBox='0 0 20 20'
                      fill='currentColor'
                    >
                      <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                    </svg>
                  </button>
                </div>
              </div>
              <div className='mt-1 rounded-lg bg-white shadow overflow-hidden'>
                {(SelectedDisciplines.length === 0 ||
                  disciplines.length ===
                  disciplineData.data?.data.disciplines.length) && (
                    <div className='py-3 px-5'>
                      <div className='text-base font-normal'>Global</div>
                      <p className='text-sm text-gray-500'>
                        Program will be applied to all disciplines.
                      </p>
                    </div>
                  )}

                {SelectedDisciplines.length !== 0 &&
                  disciplines.length !==
                  disciplineData.data?.data.disciplines.length &&
                  SelectedDisciplines.map((d, i) => {
                    return (
                      <div
                        key={d.disciplineId}
                        className={cx(
                          'flex items-start justify-between py-3 px-5',
                          i % 2 === 0 ? null : 'bg-gray-50'
                        )}
                      >
                        <div className='text-sm'>{d.name}</div>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          className='h-6 w-6 text-red-500 cursor-pointer'
                          onClick={() => handleRemoveDiscipline(d.disciplineId)}
                          viewBox='0 0 20 20'
                          fill='currentColor'
                        >
                          <path
                            fillRule='evenodd'
                            d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
                            clipRule='evenodd'
                          />
                        </svg>
                      </div>
                    );
                  })}
                </div>*/}
            </div>

            {/* Schools */}
            <div className='col-span-6 sm:col-span-6'>
              <label className='primary'>Schools</label>

              {schoolsData.data?.data.schools !== undefined &&
                schoolsData.data?.data.schools.length > 0 && (
                  <Fragment>
                    <p className='text-sm text-gray-500 mb-3'>
                      Select all applicable schools.
                    </p>
                    <div className='mt-1 rounded-lg bg-white shadow px-4 py-3'>
                      {schoolsData.data?.data.schools
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((s, i) => {
                          const sid = `school_${i}`;

                          return (
                            <div key={sid} className='flex items-start py-1'>
                              <div className='flex items-center h-5'>
                                <input
                                  id={sid}
                                  value={s.schoolId}
                                  checked={schools.includes(s.schoolId)}
                                  onChange={handleSchoolChange}
                                  name='school'
                                  type='checkbox'
                                  className='primary-checkbox'
                                />
                              </div>
                              <div className='ml-3 text-sm'>
                                <label htmlFor={sid} className='primary'>
                                  {s.name}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </Fragment>
                )}

              {(schoolsData.data?.data.schools === undefined ||
                schoolsData.data?.data.schools.length === 0) && (
                  <p className='text-sm text-gray-500 mb-3'>
                    No applicable schools.
                  </p>
                )}
            </div>
          </div>

          {/* Buttons */}
          <div className='text-right'>
            <SubmitButton
              text='Create Program'
              spinning={save.isPending}
              disabled={programName.length === 0}
              onClick={() => save.run()}
            />
          </div>
        </Fragment>
      </Layout>
    </Fragment>
  );
};

export default CreatePrograms;
